export default {
	header: {
		self: {},
		items: [
			{
			},
		]
	},
	aside: {
		self: {},
		items: [
			{
				title: "Dashboard",
				root: true,
				icon: "fas fa-tachometer-alt",
				page: "dashboard",
				bullet: "dot"
			},
			{
				title: "Vendas",
				root: true,
				icon: "fas fa-cart-plus",
				page: "pedido",
				bullet: "dot"
			},
			{
				title: "Relatórios",
				root: true,
				bullet: "dot",
				icon: "fas fa-chart-pie",
				submenu: [
					{
						title: "Vendas",
						bullet: "dot",
						page: "relatorio/relatorio01"
					},
					{
						title: "Vendas por produtos",
						bullet: "dot",
						page: "relatorio/relatorio02"
					},
				]
			},
		]
	}
};
